import React from "react"
import BackgroundVideo from "components/layouts/BackgroundVideo"
import Header from "components/layouts/header/Header"
import Footer from "components/layouts/Footer"
import Copyright from "components/layouts/Copyright"

interface CommonLayoutProps {
  children: React.ReactElement
}

const CommonLayout = ({ children }: CommonLayoutProps) => {
  return (
    <>
      <Header />
      <BackgroundVideo />
      <main>
        {children}
      </main>
      <Footer />
      <Copyright />
    </>
  )
}

export default CommonLayout